module.exports = "<div ng-include=\"ctrl.rebateScript\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/partials/comparator-step3-rebate.html
// module id = 303
// module chunks = 0